import Anchor from "atoms/anchors/anchor";
import Button from "atoms/buttons/button";
import { ButtonStyles } from "atoms/constants/button-styles";
import Trans from "atoms/i18n/trans";
import Paragraph from "atoms/typography/paragraph";
import { siteMap } from "internal-sitemap";
import React from "react";
import { useChatModal } from "utilities/hooks/domain/chat/use-chat-modal";
import useCurrentIdentity from "utilities/hooks/use-current-identity";
import { t } from "utilities/localization-utils";
import StringUtils from "utilities/string-utils";

const CSS_BASE_CLASS = "c-free-trial-banner";

interface FreeTrialBannerProps {}

const FIRST_HALF_OF_TRIAL_PERIOD_IN_DAYS = 8;

const FreeTrialBanner = (_: FreeTrialBannerProps) => {
    const { openChatModal } = useChatModal();

    const { currentIdentity } = useCurrentIdentity();
    const currentUserRole = currentIdentity?.getCurrentUserRole();
    const isFreeTrialSubscription = currentUserRole?.isFreeTrialRole();

    if (!isFreeTrialSubscription) {
        return;
    }

    const daysUntilExpiration =
        currentUserRole?.daysUntilSubscriptionExpiration();
    const day = StringUtils.pluralize(daysUntilExpiration!, t("day"));

    const expirationMessage =
        daysUntilExpiration === 0
            ? t("free-trial-banner--expires-today")
            : t("warning-freeTrialWarning-description", {
                  timeToExpiration: `${daysUntilExpiration} ${day.toLowerCase()}`,
              });

    const casiMessage = (
        <Trans key={"free-trial-banner--casi-message"}>
            Have a question? Ask our AI assistant,{" "}
            <Button
                cssClassName={`${CSS_BASE_CLASS}__anchor`}
                onClick={openChatModal}
                style={ButtonStyles.None}
                accessibleText={t("tryCasi")}>
                CASI
            </Button>
            .
        </Trans>
    );

    const notebooksMessage = (
        <Trans key={"free-trial-banner--notebooks-message"}>
            Organize your references.{" "}
            <Anchor
                cssClassName={`${CSS_BASE_CLASS}__anchor`}
                to={siteMap.notebooks.list}>
                Create a Notebook today
            </Anchor>
            .
        </Trans>
    );

    const messageToShow =
        daysUntilExpiration! >= FIRST_HALF_OF_TRIAL_PERIOD_IN_DAYS
            ? casiMessage
            : notebooksMessage;
    return (
        <div className={`${CSS_BASE_CLASS}`}>
            <Paragraph cssClassName={`${CSS_BASE_CLASS}__message`}>
                {messageToShow}
            </Paragraph>
            <Paragraph cssClassName={`${CSS_BASE_CLASS}__eyebrow`}>
                <span className={`${CSS_BASE_CLASS}__eyebrow-text`}>
                    {expirationMessage}
                </span>{" "}
                {
                    <Anchor
                        to={siteMap.account.subscription}
                        cssClassName="c-button -primary -small">
                        {t("upgrade")}
                    </Anchor>
                }
            </Paragraph>
        </div>
    );
};

export default FreeTrialBanner;
